'use strict';

export function isValidForm() {
  return [...document.querySelectorAll(".page-current form input")].every(input => input.checkValidity());
}